module.exports = __webpack_public_path__ + "static/energy-and-civilization-210e3bd61cbed0e7e7b71160d87aaf53.jpg";